<template>
  <app-layout></app-layout>
</template>

<script>
import Layout from './components/Layout.vue';

export default {
  name: 'App',
  components: {
    appLayout: Layout
  },
  mounted() {
    const _paq = (window._paq = window._paq || [])
    _paq.push(['trackPageView'])
    _paq.push(['enableLinkTracking'])

    const u = 'https://matomo.gishosting.ch/'
    _paq.push(['setTrackerUrl', u + 'matomo.php'])
    _paq.push(['setSiteId', '8'])

    const d = document
    const g = d.createElement('script')
    const s = d.getElementsByTagName('script')[0]

    g.async = true
    g.src = u + 'matomo.js'
    s.parentNode.insertBefore(g, s)
  }
}
</script>

<style>
#app {
}
</style>
